import { computed, effect, inject, Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { DatepickerRange, RangeDatepickerComponent } from '@ui/aos-lib';

import { selectDateRange } from './store/consumption-analytics.reducer';
import { TranslateService } from 'src/app/services/translate/translate.service';

@Injectable({ providedIn: 'root' })
export class ConsumptionAnalyticsDateRangeService {
  readonly #store = inject(Store);
  readonly #translate = inject(TranslateService);

  readonly #dateRange = this.#store.selectSignal(selectDateRange);

  readonly shiftDateToMinusOne: (date: Date) => Date = (date: Date): Date => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() - 1);
    return newDate;
  };

  public formControl: FormControl | null = null;

  public readonly presets = computed(() =>
    this.#translate
      .translateDatepickerPresets([
        RangeDatepickerComponent.YESTERDAY,
        RangeDatepickerComponent.LAST_WEEK,
        RangeDatepickerComponent.LAST_TWO_WEEK,
        RangeDatepickerComponent.LAST_MONTH,
        RangeDatepickerComponent.LAST_THREE_MONTHS,
        RangeDatepickerComponent.LAST_YEAR
      ])()
      .map(preset => {
        if (preset.title !== RangeDatepickerComponent.YESTERDAY.title) {
          return {
            ...preset,
            getValue: (): DatepickerRange => {
              const { start, end } = preset.getValue() as { start: Date; end: Date };
              return {
                start: this.shiftDateToMinusOne(start),
                end: this.shiftDateToMinusOne(end)
              };
            }
          };
        }

        return preset;
      })
  );

  constructor() {
    effect(() => {
      const dateRange = this.#dateRange();
      if (dateRange && !this.formControl) {
        this.formControl = new FormControl(dateRange, { nonNullable: true });
      }
    });
  }
}
